import { render } from "./SignUpList.vue?vue&type=template&id=20580509"
import script from "./SignUpList.vue?vue&type=script&lang=js"
export * from "./SignUpList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__